import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#9A9956",
    "col1n": "#C4C389",
    "col2n": "#FFFFFF"
}
function PlaInd041({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M385 65.05l-35.15-55.6Q198.2-9.4 44.7 9.45L0 70.35v70.95h385V65.05z"
                    id="PlaInd041__Symbol_110_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M359 21.3q-.35-.35-.85-.35h-67.3L279.6.65q-.25-.45-.7-.6-.5-.15-.9.1-.45.25-.6.75-.15.45.1.9l10.65 19.15h-63.2L221.35 1q-.1-.5-.5-.75-.45-.3-.9-.2-.5.05-.75.5-.3.4-.2.9l3.55 19.5h-63.3L163 1.45q.05-.5-.2-.9-.3-.45-.75-.5-.5-.1-.9.15-.45.3-.5.8l-3.85 19.95H94.3L105.2 1.8q.25-.45.1-.9-.1-.5-.55-.75-.45-.25-.9-.1-.5.15-.75.55L91.5 20.95H27.45q-.5 0-.85.35t-.35.85q0 .5.35.85t.85.35h62.7L72.1 54.95H0v2.4h70.75L43.4 105.3h2.8l27.3-47.95h76.3l-9.15 47.95h2.4l9.2-47.95h76.8l8.7 47.95h2.4l-8.65-47.95h76.25q.35 0 .6-.15l.05.05q-.05.35.15.7l26.2 47.35h2.75L311 57.35h74v-2.4h-75.45q-.05-.2-.15-.4l-17.2-31.2h65.95q.5 0 .85-.35t.35-.85q0-.5-.35-.85m-69.55 2.05l17.45 31.6h-75.6q-.15 0-.25.05v-.2l-5.65-31.45h64.05m-66.5 0l5.7 31.6H152.7l6.1-31.6h64.15m-130.05 0h63.45l-6.1 31.6H74.9l18-31.6z"
                    id="PlaInd041__Symbol_111_0_Layer0_0_FILL"
                />
                <path
                    fill="#BFBFBF"
                    fillOpacity={0.749}
                    d="M385 394.25V318l-35.2-55.6H44.7L0 323.25v71h385z"
                    id="PlaInd041__Layer7_0_MEMBER_0_FILL"
                />
                <path
                    fill="#7F838C"
                    d="M0 339.65l34.4-36.2q17.646-148.63 0-295.3Q19.379-6.044 0-19.4v359.05m351.2-36.2l33.8 36.9v-359.9q-18.379 11.874-33.8 27.7-19.485 147.65 0 295.3z"
                    id="PlaInd041__Layer7_1_FILL"
                />
                <path
                    fill="#8C9098"
                    d="M351.2 303.45V8.15q-158.4-2.258-316.8 0v295.3h49.2l9-13.3H293l9 13.3h49.2z"
                    id="PlaInd041__Layer7_2_FILL"
                />
                <path
                    fill="#666B77"
                    d="M344.8 223V108.95h-36.6V223h36.6z"
                    id="PlaInd041__Layer7_3_MEMBER_0_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M316.8 146.7q1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.25 0-1.95-1.35-3.3-1.35-1.35-3.3-1.35-1.9 0-3.25 1.35-1.4 1.35-1.4 3.3 0 1.9 1.4 3.25z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_0_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M329.3 140.2q-1.4 1.35-1.4 3.25 0 1.95 1.4 3.3 1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_1_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M316.75 159.85q1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4-1.4 1.35-1.4 3.25 0 1.95 1.4 3.3z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_2_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M332.5 151.9q-1.9 0-3.25 1.4-1.35 1.35-1.35 3.25 0 1.95 1.35 3.3 1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_3_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M316.75 172.95q1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4-1.4 1.35-1.4 3.25 0 1.95 1.4 3.3z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_4_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M329.25 172.95q1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4-1.35 1.35-1.35 3.25 0 1.95 1.35 3.3z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_5_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M316.75 186q1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4-1.4 1.35-1.4 3.25 0 1.95 1.4 3.3z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_6_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M329.25 179.45q-1.35 1.35-1.35 3.25 0 1.95 1.35 3.3 1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.3 0-1.9-1.35-3.25-1.35-1.4-3.3-1.4-1.9 0-3.25 1.4z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_7_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M316.75 192.5q-1.4 1.35-1.4 3.3 0 1.9 1.4 3.25 1.35 1.35 3.25 1.35 1.95 0 3.3-1.35 1.35-1.35 1.35-3.25 0-1.95-1.35-3.3-1.35-1.35-3.3-1.35-1.9 0-3.25 1.35z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_8_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M332.5 191.15q-1.9 0-3.25 1.35t-1.35 3.3q0 1.9 1.35 3.25t3.25 1.35q1.95 0 3.3-1.35 1.35-1.35 1.35-3.25 0-1.95-1.35-3.3-1.35-1.35-3.3-1.35z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_9_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M324.35 213.05q1 1 2.5 1t2.55-1q1.05-1.05 1.05-2.55 0-1.5-1.05-2.55-1.05-1.05-2.55-1.05-1.5 0-2.5 1.05-1.05 1.05-1.05 2.55 0 1.5 1.05 2.55z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_10_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M333.3 210.5q0 1.5 1.05 2.55 1 1 2.5 1t2.55-1q1.05-1.05 1.05-2.55 0-1.5-1.05-2.55-1.05-1.05-2.55-1.05-1.5 0-2.5 1.05-1.05 1.05-1.05 2.55z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_11_FILL"
                />
                <path
                    fill="#9399A6"
                    d="M314.35 207.95q-1.05 1.05-1.05 2.55 0 1.5 1.05 2.55 1 1 2.5 1t2.55-1q1.05-1.05 1.05-2.55 0-1.5-1.05-2.55-1.05-1.05-2.55-1.05-1.5 0-2.5 1.05z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_12_FILL"
                />
                <path
                    d="M340.1 131.6v-15.1h-27.2v15.1h27.2z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_13_FILL"
                />
                <path
                    fill="#3D3F46"
                    d="M340.7 218q-.4.4-.4 1t.4 1q.4.4 1 .4t1-.4q.4-.4.4-1t-.4-1q-.4-.4-1-.4t-1 .4z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_14_FILL"
                />
                <path
                    fill="#3D3F46"
                    d="M312.7 219q0-.6-.4-1t-1-.4q-.6 0-1 .4t-.4 1q0 .6.4 1t1 .4q.6 0 1-.4t.4-1z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_15_FILL"
                />
                <path
                    fill="#3D3F46"
                    d="M343.1 112.6q0-.6-.4-1t-1-.4q-.6 0-1 .4t-.4 1q0 .6.4 1t1 .4q.6 0 1-.4t.4-1z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_16_FILL"
                />
                <path
                    fill="#3D3F46"
                    d="M312.3 113.6q.4-.4.4-1t-.4-1q-.4-.4-1-.4t-1 .4q-.4.4-.4 1t.4 1q.4.4 1 .4t1-.4z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_17_FILL"
                />
                <path
                    fill="#202125"
                    d="M318.65 193.45q-.4.7-.4 2 0 1.45.45 2.1.45.65 1.25.65t1.25-.7q.45-.7.45-2 0-1.35-.45-2.05-.45-.7-1.25-.7h-.05q-.8 0-1.25.7m1.25.45q.35 0 .45.4.15.4.15 1.25 0 .8-.15 1.15-.1.4-.45.4-.55 0-.55-1.65 0-1.55.55-1.55m-1.35-12.8q-.05.35-.05.9h1.1v-.2q0-.5.1-.65.05-.2.25-.2.15 0 .25.15t.1.35q0 .4-.3.95l-1.7 2.85h2.95v-1.05h-1.05l.65-1.1q.3-.5.4-.9.15-.4.15-.8 0-.7-.35-1.05-.4-.4-1.1-.4-.45 0-.75.15t-.45.45q-.15.25-.2.55m-.25-10.65v.8h1.65v1.05H321v-1.05h.4v-.9h-.4v-3.2h-1.2l-1.5 3.3m1.65-.1h-.75l.75-1.65v1.65m-.4-16.5l-.35.75q-.9 1.8-.9 2.75 0 .8.45 1.3t1.15.5q.8 0 1.25-.5.45-.5.45-1.3t-.35-1.2q-.35-.4-1-.4h-.2q-.1.05-.15.05.2-.6.85-1.95h-1.2m.8 3q.15.2.15.55 0 .3-.15.5t-.4.2q-.25 0-.4-.2-.1-.2-.1-.5 0-.35.15-.55.15-.2.35-.2.25 0 .4.2m1-14.85q0-.6-.4-.95-.4-.4-1-.4-.65 0-1.05.4-.4.35-.4.9 0 .3.1.55.1.25.3.4.15.1.35.2v.05h.05q-.15.1-.3.15-.15.1-.25.2t-.15.25q-.05.1-.1.25-.05.1-.1.25v.35q0 .7.4 1.1.4.4 1.15.4.7 0 1.1-.4.45-.45.45-1.1 0-.5-.25-.9-.25-.35-.7-.55.4-.2.6-.5.2-.25.2-.65m-1.4-.4q.3 0 .3.55 0 .5-.3.5-.15 0-.25-.1-.05-.15-.05-.45 0-.5.3-.5m0 3.55q-.45 0-.45-.7t.45-.7q.4 0 .4.75 0 .65-.4.65m11.5 48.85h.65v4.05h1.1v-5.15h-1.75v1.1m1.15-14q-.35 0-.65.1-.25.15-.45.4-.15.25-.25.5-.05.25-.05.65h1.1v-.1q0-.3.05-.45.05-.15.25-.15.35 0 .35.65 0 .3-.1.45-.1.1-.35.1h-.4v1.05h.35q.25 0 .4.15.1.1.1.4 0 .65-.4.65-.35 0-.35-.45h-1.1q0 .65.45 1.05.4.4 1.05.4.45 0 .8-.2.3-.15.5-.5.15-.35.15-.75 0-.9-.7-1.25.6-.45.6-1.2 0-.65-.4-1.1-.35-.4-.95-.4m1.25-11.8v-1.05h-2.15l-.4 2.75q.35-.1.55-.1.45 0 .7.2.25.2.25.55 0 .45-.2.65-.2.25-.5.25t-.85-.25l-.15 1q.7.25 1.15.25.75 0 1.2-.5.45-.5.45-1.35 0-.75-.35-1.2-.4-.4-1.15-.45l.1-.75h1.35m-1.1-13.3l-1.55 4.1h1.2l1.95-5.15h-3.05v1.05h1.45m-.2-14.25q-.75 0-1.2.5-.45.5-.45 1.3 0 .75.35 1.2.35.4.95.4.2 0 .45-.05l-.9 1.95h1.2q.75-1.55.9-1.95.15-.4.25-.85.1-.45.1-.75 0-.8-.45-1.25-.45-.5-1.2-.5m0 1q.25 0 .4.2.15.2.15.55 0 .3-.15.55-.15.2-.4.2t-.4-.2q-.15-.2-.15-.55 0-.35.2-.55.15-.2.35-.2z"
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_18_MEMBER_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M385 5.15V0H0v4.85q16.15 15.3 36.75 27.65 155.85 4.65 311.75 0Q368.2 20.75 385 5.15z"
                    id="PlaInd041__Symbol_109_0_Layer0_0_FILL"
                />
                <path
                    fill="url(#PlaInd041__Gradient_1)"
                    d="M351.2 289.2V8.15H34.4V289.2h316.8z"
                    id="PlaInd041__Layer2_0_FILL"
                />
                <path
                    fill="#A1A4AB"
                    d="M38.15 226.3v-21.1Q17.201 211.868 0 220.75v26.2l38.15-20.65M385 246.7v-26.15q-16.602-8.112-37.7-15.35v21.1l37.7 20.4z"
                    id="PlaInd041__Layer2_1_FILL"
                />
                <path
                    fill="#747880"
                    d="M0 218.4v2.35l38.15-15.55H34.1L0 218.4z"
                    id="PlaInd041__Layer2_1_MEMBER_0_FILL"
                />
                <path
                    fill="#747880"
                    d="M385 220.55v-2.35l-33.65-13h-4.05l37.7 15.35z"
                    id="PlaInd041__Layer2_1_MEMBER_1_FILL"
                />
                <path
                    fill="#A8AEBB"
                    d="M0-25.15v6.75L34.4 8.15h316.8l33.8-26.1v-6.8l-36.55 29.1H36.75L0-25.15z"
                    id="PlaInd041__Layer2_3_FILL"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_0_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M320.05 148.05q-1.9 0-3.25-1.35-1.4-1.35-1.4-3.25 0-1.95 1.4-3.3 1.35-1.35 3.25-1.35 1.95 0 3.3 1.35 1.35 1.35 1.35 3.3 0 1.9-1.35 3.25t-3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_1_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M327.9 143.45q0-1.9 1.4-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35-1.9 0-3.25-1.35-1.4-1.35-1.4-3.3z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_2_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M320 161.2q-1.9 0-3.25-1.35-1.4-1.35-1.4-3.3 0-1.9 1.4-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_3_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M329.25 153.3q1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35-1.9 0-3.25-1.35t-1.35-3.3q0-1.9 1.35-3.25z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_4_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M320 174.3q-1.9 0-3.25-1.35-1.4-1.35-1.4-3.3 0-1.9 1.4-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_5_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M332.5 174.3q-1.9 0-3.25-1.35t-1.35-3.3q0-1.9 1.35-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_6_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M320 187.35q-1.9 0-3.25-1.35-1.4-1.35-1.4-3.3 0-1.9 1.4-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_7_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M327.9 182.7q0-1.9 1.35-3.25 1.35-1.4 3.25-1.4 1.95 0 3.3 1.4 1.35 1.35 1.35 3.25 0 1.95-1.35 3.3-1.35 1.35-3.3 1.35-1.9 0-3.25-1.35t-1.35-3.3z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_8_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M323.3 192.5q1.35 1.35 1.35 3.3 0 1.9-1.35 3.25t-3.3 1.35q-1.9 0-3.25-1.35-1.4-1.35-1.4-3.25 0-1.95 1.4-3.3 1.35-1.35 3.25-1.35 1.95 0 3.3 1.35z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_9_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.3}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M329.25 192.5q1.35-1.35 3.25-1.35 1.95 0 3.3 1.35 1.35 1.35 1.35 3.3 0 1.9-1.35 3.25t-3.3 1.35q-1.9 0-3.25-1.35t-1.35-3.25q0-1.95 1.35-3.3z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_10_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.2}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M326.85 214.05q-1.5 0-2.5-1-1.05-1.05-1.05-2.55 0-1.5 1.05-2.55 1-1.05 2.5-1.05t2.55 1.05q1.05 1.05 1.05 2.55 0 1.5-1.05 2.55-1.05 1-2.55 1z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_11_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.2}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M334.35 213.05q-1.05-1.05-1.05-2.55 0-1.5 1.05-2.55 1-1.05 2.5-1.05t2.55 1.05q1.05 1.05 1.05 2.55 0 1.5-1.05 2.55-1.05 1-2.55 1-1.5 0-2.5-1z"
                />
                <path
                    id="PlaInd041__Layer7_3_MEMBER_1_MEMBER_12_1_STROKES"
                    stroke="#C1C7D4"
                    strokeWidth={1.2}
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    fill="none"
                    d="M313.3 210.5q0-1.5 1.05-2.55 1-1.05 2.5-1.05t2.55 1.05q1.05 1.05 1.05 2.55 0 1.5-1.05 2.55-1.05 1-2.55 1-1.5 0-2.5-1-1.05-1.05-1.05-2.55z"
                />
                <linearGradient
                    id="PlaInd041__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={192.8}
                    y1={17.8}
                    x2={192.8}
                    y2={283}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.702} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="PlaInd041__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    x1={-124}
                    y1={-3.85}
                    x2={-124}
                    y2={296.05}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.702} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="PlaInd041__Gradient_3"
                    gradientUnits="userSpaceOnUse"
                    x1={-124}
                    y1={14.4}
                    x2={-124}
                    y2={186}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.702} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="PlaInd041__Gradient_4"
                    gradientUnits="userSpaceOnUse"
                    x1={509.6}
                    y1={-3.85}
                    x2={509.6}
                    y2={296.05}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.702} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="PlaInd041__Gradient_5"
                    gradientUnits="userSpaceOnUse"
                    x1={509.6}
                    y1={14.4}
                    x2={509.6}
                    y2={186}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.702} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <g id="PlaInd041__Layer2_0_MEMBER_0_FILL">
                    <path
                        fill="url(#PlaInd041__Gradient_2)"
                        d="M34.4 38.8H0v299.3l34.4-35.05V38.8z"
                    />
                    <path
                        fill="url(#PlaInd041__Gradient_3)"
                        d="M0 38.8h34.4V8.15L0-18.4v57.2z"
                    />
                    <path
                        fill="url(#PlaInd041__Gradient_4)"
                        d="M385 38.8h-33.8v264.25L385 338.4V38.8z"
                    />
                    <path
                        fill="url(#PlaInd041__Gradient_5)"
                        d="M351.2 8.15V38.8H385v-56.75l-33.8 26.1z"
                    />
                </g>
                <g id="PlaInd041__Layer2_2_FILL">
                    <path
                        fill="#797C85"
                        d="M92.6 36.65l-8.95-9.2h-.05v276l9-13.3V36.65z"
                    />
                    <path
                        fill="#7F838C"
                        d="M301.95 27.45l-8.95 9.2v253.5l9 13.3v-276h-.05z"
                    />
                    <path
                        fill="#696D74"
                        d="M293 36.65l8.95-9.2H83.65l8.95 9.2h99.25v253.5h1.45V36.65H293z"
                    />
                </g>
            </defs>
            <use
                xlinkHref="#PlaInd041__Symbol_110_0_Layer0_0_FILL"
                transform="translate(0 252.95)"
                id="PlaInd041__col1n"
            />
            <use
                xlinkHref="#PlaInd041__Symbol_111_0_Layer0_0_FILL"
                transform="translate(0 288.95)"
                id="PlaInd041__col1d"
            />
            <use xlinkHref="#PlaInd041__Layer7_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_1_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_2_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_0_FILL" />
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_0_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_0_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_1_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_1_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_2_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_2_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_3_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_3_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_4_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_4_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_5_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_5_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_6_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_6_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_7_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_7_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_8_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_8_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_9_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_9_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_10_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_10_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_11_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_11_1_STROKES" />
            </g>
            <g>
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_12_FILL" />
                <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_12_1_STROKES" />
            </g>
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_13_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_14_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_15_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_16_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_17_FILL" />
            <use xlinkHref="#PlaInd041__Layer7_3_MEMBER_1_MEMBER_18_MEMBER_0_FILL" />
            <use
                xlinkHref="#PlaInd041__Symbol_109_0_Layer0_0_FILL"
                transform="translate(0 -28.15)"
                id="PlaInd041__col2n"
            />
            <use xlinkHref="#PlaInd041__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_1_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_1_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_1_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_2_FILL" />
            <use xlinkHref="#PlaInd041__Layer2_3_FILL" />
        </g></g>
    )
}
export default PlaInd041
